import { z } from 'zod';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { requiredString } from '@/utils/zodUtils';

export const ChangeUserByIdSchema = (t: GetTextIdTranslationType) =>
  z
    .object({
      newUserId: requiredString(t),
    })
    .strict();

export type ChangeUserByIdType = z.infer<ReturnType<typeof ChangeUserByIdSchema>>;
